import { Grid } from '@mui/material';
import { FILTERS_ARRAY } from '../../constants/Constants';
import { BakeasyChipFilterCancel } from './BakeasyChip';

export interface BakeasySelectedFilter {
  filter: any;
  onDelete: any;
}

function BakeasySelectedFilters(props: BakeasySelectedFilter) {
  return (
    <Grid sx={{ mt: 1, mb: -1 }}>
      {Object.entries(props?.filter).map((item: any, index: number) => {
        if (!FILTERS_ARRAY.includes(item[0])) {
          return (
            <BakeasyChipFilterCancel
              key={index}
              label={item[0] + ' : ' + item[1]}
              onDelete={() => {
                props?.onDelete(item[0]);
              }}
            />
          );
        }
      })}
    </Grid>
  );
}

export default BakeasySelectedFilters;
